// extracted by mini-css-extract-plugin
module.exports = {"header":"h4","headerBg":"h5"};